import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Gallery from "@/components/Gallery";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import ServiceArea from "@/components/ServiceArea";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <Hero />
      <Marquee />
      <Pricing />
      <Services />
      <WhyUs />
      <Gallery />
      <Process />
      <ServiceArea />
      <Reviews />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}
